import { Group, Text, rem } from '@mantine/core'
import { IconUpload, IconPhoto, IconX } from '@tabler/icons-react'
import { Dropzone, DropzoneProps, FileRejection } from '@mantine/dropzone'
import '@mantine/dropzone/styles.css'
import { useTranslation } from 'react-i18next'
import { showNotification } from '@mantine/notifications'
import { MAX_FILE_SIZE_BYTES, MAX_FILE_SIZE_MB } from 'utils/constants'

export function UploadDropzone(props: Partial<DropzoneProps>) {
  const { t } = useTranslation()

  const handleReject = (files: FileRejection[]) => {
    files.forEach((file) => {
      const error = file.errors[0]
      if (error?.code === 'file-too-large') {
        showNotification({
          title: 'File too large',
          message: `${file.file.name} exceeds the maximum size of ${MAX_FILE_SIZE_MB}MB`,
          color: 'red',
        })
      } else {
        showNotification({
          title: 'File rejected',
          message: `${file.file.name}: ${error?.message || 'Unknown error'}`,
          color: 'red',
        })
      }
    })
  }

  return (
    <Dropzone onDrop={props.onDrop || (() => {})} onReject={handleReject} maxSize={MAX_FILE_SIZE_BYTES} {...props}>
      <Group justify="center" gap="xl" mih={80} style={{ pointerEvents: 'none' }}>
        <Dropzone.Accept>
          <IconUpload style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-blue-6)' }} stroke={1.5} />
        </Dropzone.Accept>
        <Dropzone.Reject>
          <IconX style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-red-6)' }} stroke={1.5} />
        </Dropzone.Reject>
        <Dropzone.Idle>
          <IconPhoto style={{ width: rem(52), height: rem(52), color: 'var(--mantine-color-dimmed)' }} stroke={1.5} />
        </Dropzone.Idle>

        <div>
          <Text size="xl" inline>
            {t('upload.drag')}
          </Text>
          <Text size="sm" c="dimmed" inline mt={7}>
            {t('upload.attach', { maxSize: MAX_FILE_SIZE_MB })}
          </Text>
        </div>
      </Group>
    </Dropzone>
  )
}
